<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      @openAddDialog="updateInfo"
      :submitService="submitService"
      addShowPower="/tatinfo/add"
      :submitData="submitData"
      @success="onSuccess"
    >
      <el-form-item label="机构名称" prop="name">
        <el-input
          v-model="formModel.name"
          maxlength="20"
          placeholder="请输入机构名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="机构状态" prop="status">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="tatName"
        fixed
        label="机构名称"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="orderNumber"
        fixed
        label="机构序号"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="appName"
        label="应用名称"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="status"
        label="机构状态"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterEnable"
      ></el-table-column>
      <el-table-column
        prop="regionProxyStatus"
        label="区域代理"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterEnable"
      ></el-table-column>
      <el-table-column
        prop="enableApplyWithDraw"
        label="机构提现"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterEnable"
      ></el-table-column>
      <el-table-column
        prop="enableArtificialStopSend"
        label="机构短信"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterEnable"
      ></el-table-column>
      <el-table-column
        prop="enablePublicPlatoon"
        label="公排管理"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterEnable"
      ></el-table-column>
      <el-table-column
        prop="enablePublicPlatoonSenior"
        label="高级公排管理"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterEnable"
      ></el-table-column>
      <el-table-column
        prop="integralSwitch"
        label="积分商城"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterEnable"
      ></el-table-column>
      <el-table-column
        prop="connPerson"
        label="联系人"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="connTel"
        label="联系电话"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="defaultPhone"
        label="默认推荐人"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="region"
        label="所属区域"
        min-width="160"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.province }} {{ scope.row.city }} {{ scope.row.area }}
        </template>
      </el-table-column>
      <el-table-column
        prop="validEnd"
        label="合同到期时间"
        min-width="160"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="创建时间"
        min-width="160"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column label="操作" fixed="right" min-width="380">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="updateInfo(scope.row.id)"
            v-if="hasPerm('/tatinfo/edit')"
            >基础配置</el-button
          >
          <el-button
            type="text"
            @click="handleSet(scope.row, 'organmanageparams')"
            v-if="hasPerm('/tatinfo/edit')"
            >参数配置</el-button
          >
          <el-button
            type="text"
            @click="handleSet(scope.row, 'organmanagegoods')"
            v-if="hasPerm('/tatinfo/edit')"
            >商品配置</el-button
          >
          <el-button
            type="text"
            @click="handleSet(scope.row, 'publicplatoongoods')"
            v-if="hasPerm('/tatinfo/edit')"
            >蒲公英商城</el-button
          >
          <el-button
            type="text"
            @click="Disabled(scope.row.id, scope.row.status)"
            class="button-color"
            v-if="hasPerm('/tatinfo/udpStatus')"
            >{{ scope.row.status == 1 ? "禁用" : "启用" }}</el-button
          >
        </template>
      </el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import OrganService from "service/OrganService";
import EnableStatus from "service/constant/EnableStatus";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import StorageService from "store/interfaces";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "organmanage",
  data() {
    return {
      options: EnableStatus,
      formModel: {
        name: "",
        status: "",
      },
      tableData: [],
      submitService: OrganService.list,
      page: {},
      status: "",
      showMsg: "",
      isPage: false,
    };
  },
  mixins: [loadMixin, dialogMixin],
  components: {
    CommonTopForm,
    CommonTable,
  },
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getList();
  },
  activated() {
    if (this.reloadPage) {
      this.getList();
    }
  },
  computed: {
    submitData() {
      const params = {
        tatName: this.formModel.name.trim(),
        tatStatus: this.formModel.status,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "reloadPage"]),
  },
  methods: {
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        OrganService.list,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isReloadPage(false);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(data) {
      this.doCheck(data, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    updateInfo(id) {
      this.$router.push({
        name: "addorganmanage",
        params: {
          id: id,
        },
      });
    },
    doDisabled(id) {
      const disabledParams = {
        id: id,
        status: this.status,
        userId: this.userId,
      };
      this.doLoad(
        OrganService.prohibit,
        disabledParams,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.showSuccess(result.optMsg);
            this.getList();
          });
        },
        "操作失败"
      );
    },
    Disabled(id, type) {
      if (type == 0) {
        this.status = 1;
        this.showMsg = "确定启用此机构？";
      } else if (type == 1) {
        this.status = 0;
        this.showMsg = "确定禁用此机构？";
      }
      this.showConfirm(this.showMsg)
        .then(() => {
          this.doDisabled(id);
        })
        .catch(() => {});
    },
    handleSet(item, url) {
      console.log(url);
      this.$router.push({
        name: url,
        params: {
          item: JSON.stringify(item),
        },
      });
    },
    ...mapActions({
      isReloadPage: StorageService.Reload.page,
    }),
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/OrganManage.vue